// generated from 1_368 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasProvisionalPushByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_provisional_push_by_app_filter"),
  comparison_key: z.literal("1"),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 738 (53.95%), defined 630 (46.05%)
  // true 553 (87.78%), false 77 (12.22%)
  raw_value: z.boolean().optional(),
  // true 830 (60.67%), false 538 (39.33%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
